import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'

const ChatBotRecordDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [detail, setDetail] = useState({})

  useEffect(() => {
    axios.post('/p/chatbot/record/detail/get', {
      merchant_oid: merchantOid,
      conversation_id: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid, props.data])

  const handleCancel = () => {
    props.isCancel()
  }

  return (
    <Modal 
      title="会话详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>

      <div className='public-datail-container'>
        {detail.length > 0 && detail.map((item) => (
          <div className='public-datail-item2'>
            <div className='public-datail-label2'>{item.create_time}</div>
            <div className='public-datail-content2'>Q：{item.user_question}</div>
            <div className='public-datail-content2'>A：{item.assistant_answer}</div>
            <div className='public-datail-content2'>回答内容来源于《{item.source}》</div>
          </div>
        ))}

        {detail.length === 20 && <div>仅展示最近20条对话记录</div>}
      </div>
    </Modal>
  )
}

export default ChatBotRecordDetail
